import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './components/homePage/Home'
import ProductsPage from './components/productsPage/new/ProductsPage.jsx';
import Contact from './components/contactPage/Contact';
import Careers from './components/careersPage/Careers';
import JobDetail from './components/careersPage/JobDetails';
import SignIn from './components/signIn/SignIn';
import AdminPage from './components/adminPage/AdminPage';
import Scroll from './components/Scroll';
import SocialMediaButtons from './components/SocialMediaButtons';
import ProductDetail from './components/productsPage/ProductDetail';
import AddClients from './components/adminPage/AddClientCompononents/AddClients';
import AddCategories from './components/adminPage/AddCategoriesComponents/AddCategories';
import AddProducts from './components/adminPage/AddProductComponents/AddProducts';
// import AddManuals from './components/adminPage/AddManuals/AddManuals';
import AddCareers from './components/adminPage/AddCareers/addCareers';
import AddTestimonials from './components/adminPage/AddTestimonials/AddTestimonials';
import NotFound from './components/NotFound';
import AdminCareers from './components/adminPage/AddCareers/Careers';
import AdminJobDetail from './components/adminPage/AddCareers/JobDetails';
import Footer from './components/homePage/new/Footer.jsx';
import { FETCH_CATEGORIES_API } from './components/Api';
import { useState, useEffect } from "react";
import NewNav from "./components/navbar/NewNav.jsx";
import ContactUsPage from './components/contactPage/new/ContactPage.jsx';
import AboutProduct from "./components/productsPage/new/AboutProduct.jsx"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  const [categories, setCategories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchCategoriesFromServer() {
      try {
        const response = await fetch(FETCH_CATEGORIES_API);
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const categoriesData = await response.json();

        // ✅ Sort by uId ascending
        const sortedCategories = categoriesData.sort((a, b) => a.uId - b.uId);

        setCategories(sortedCategories);
      } catch (error) {
        setError(error.message);
      }
    }

    fetchCategoriesFromServer();
  }, []);


  const router = createBrowserRouter([
    {
      path: "/",
      element: (<>
        <NewNav categories={categories} />
        <Home />
      </>)
    },

    {
      path: "/products/:categoryId/:subCategoryId?",
      element: (<>
        <NewNav categories={categories} />
        <ProductsPage />
      </>)
    },
    {
      path: "/products/:categoryId/:subCategoryId/:productId",
      element: (<>
        <NewNav categories={categories} />
        <AboutProduct />
      </>)
    },
    {
      path: "/products/:categoryId/:subCategoryId/:productId/:categoryName/:subCategoryName",
      element: (<>
        <NewNav categories={categories} />
        <ProductDetail />
      </>)
    },
    {
      path: "/careers",
      element: (<>
        <NewNav categories={categories} />
        <Careers />
      </>)
    },
    {
      path: "/careers/jobdetails/*",
      element: (<>
        <NewNav categories={categories} />
        <JobDetail />
      </>)
    },
    {
      path: "/contact",
      element: (<>
        <NewNav categories={categories} />
        <ContactUsPage />
      </>)
    },

    {
      path: "/signin",
      element: <SignIn />
    },
    {
      path: "/admin",
      element: <AdminPage />
    },
    {
      path: "/addproduct",
      element: <AddProducts />
    },
    {
      path: "/addclient",
      element: <AddClients />
    },
    {
      path: "/addcategory",
      element: <AddCategories />
    },
    {
      path: "/addtestimonial",
      element: <AddTestimonials />
    },
    // {
    //   path: "/addmanual",
    //   element: <AddManuals /> 
    // },
    {
      path: "/admincareer",
      element: <AdminCareers />
    },
    {
      path: "/admincareer/addcareer/*",
      element: <AddCareers />
    },
    {
      path: "/admincareer/jobdetails/*",
      element: <AdminJobDetail />
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ])
  return (
    <div className="w-full">


      {/* 
        <Route path="/" element={<Home />} />
        <Route path="/products/:id" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/knowledgecenter" element={<KnowledgeCenter />} />
        <Route path="/support" element={<Support />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/admin" element={<Protected>  <AdminPage /> </Protected>} />
        <Route path="/addproduct" element={<Protected>  <AddProduct /> </Protected>} />
        <Route path="/showproducts" element={<Protected>  <ViewProducts /> </Protected>} />
        */}

      <RouterProvider router={router} ></RouterProvider>
      <Footer categories={categories} />
      {/* <Scroll /> */}
      {/* <SocialMediaButtons /> */}

          <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

    </div>
  );
}

export default App;
